import { chain, fromNullable, none, some } from "fp-ts/lib/Option";

import { O } from "@scripts/fp-ts";

export type TypeOrOptionalType<A> = A | O.Option<A>;
export function fromNullableOrOption<A>(a: TypeOrOptionalType<A>): O.Option<NonNullable<A>> {
  return O.is(a) ? chain(fromNullable)(a) : a != null ? some(a) : none;
}
